import React from "react";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
const INITIAL_LOGIN_WRAPPER_STATE = {
  challengeName: null,
  challengeParameters: null,
  showVerifyScreen: false,
  isPhoneNumberVerify: false,
  phoneExistInCognito: false,
  phoneNumberRedacted: null,
  phoneNumberNotExistDDB: true,
  isMfaChallenged: false,
  mfaLoginPage: true //EMA purpose only
};
export const useLoginWrapper = () => {
  const log = pilog.getLogger("LoginWrapperHook useLoginWrapper");
  const [mfaLoginState, setMfaLoginState] = React.useState(INITIAL_LOGIN_WRAPPER_STATE);
  React.useEffect(() => {
    log.debug("mfaLoginState", mfaLoginState);
  }, [mfaLoginState]);
  const mfaVerifyScreenCallback = ({
    isPhoneNumberVerify,
    phoneExistInCognito,
    mfaLoginPage
  }) => {
    setMfaLoginState({
      showVerifyScreen: false,
      isPhoneNumberVerify,
      phoneExistInCognito,
      mfaLoginPage: mfaLoginPage || true,
      mfaVerifySuccessCB: () => setMfaLoginState({
        showVerifyScreen: false,
        isPhoneNumberVerify: true
      })
    });
  };
  const mfaCogntioChallengePass = () => {
    setMfaLoginState({
      isMfaChallenged: false,
      mfaLoginPage: true
    });
  };

  // once the verification is completed

  const mfaVerifyScreenSuccessCB = phoneDetails => {
    setMfaLoginState({
      showVerifyScreen: true,
      mfaLoginPage: true,
      isPhoneNumberVerify: phoneDetails && phoneDetails.isPhoneNumberVerify ? phoneDetails.isPhoneNumberVerify : true,
      phoneExistInCognito: phoneDetails && phoneDetails.phoneExistInCognito ? phoneDetails.phoneExistInCognito : true
    });
  };
  const mfaVerifySuccessCB = code => {
    setMfaLoginState({
      showVerifyScreen: false,
      isPhoneNumberVerify: true,
      mfaLoginPage: true
    });
    mfaLoginState.mfaVerifySuccessCB(code);
  };
  const mfaRequestCodeSuccessCB = () => {
    setMfaLoginState({
      showVerifyScreen: false,
      isPhoneNumberVerify: false,
      phoneExistInCognito: true,
      isMfaChallenged: true
    });
  };
  const mfaPhoneChallengeCB = (challengeName, challengeParameters) => {
    setMfaLoginState({
      isMfaChallenged: true,
      challengeName,
      challengeParameters,
      showVerifyScreen: true
    });
  };
  return {
    mfaLoginState,
    mfaVerifySuccessCB,
    mfaVerifyScreenCallback,
    mfaVerifyScreenSuccessCB,
    mfaRequestCodeSuccessCB,
    mfaPhoneChallengeCB,
    mfaCogntioChallengePass
  };
};